import { memo, useEffect, useState } from "react";
import { useDrag, useDrop } from "react-dnd";
import { ItemTypes } from "../ItemTypes";
import { Label } from "@material-ui/icons";
import {
  Input,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
  TextField
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Copiar from "../../../../images/icons/copiar.svg";
import Lixeira from "../../../../images/icons/lixeira.svg";

const style = {
  marginBottom: "1rem",
  backgroundColor: "white",
  cursor:"move"
};

export const CardCampo = memo(function CardCampo({
  id,
  obrigatorio,
  nomeCampo,
  ordemCampo,
  salvarInputNomeCampo,
  salvarCheckboxObrigatorio,
  moverCard,
  encontrarCard,
  duplicarCard,
  excluirCard,
}) {
  const [checkboxObrigatorio, setCheckboxObrigatorio] = useState(
    obrigatorio == true ? true : false
  );

  const originalIndex = encontrarCard(id).index;

  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: ItemTypes.CARD,
      item: { id, originalIndex },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
      end: (item, monitor) => {
        const { id: droppedId, originalIndex } = item;
        const didDrop = monitor.didDrop();
        if (!didDrop) {
          moverCard(droppedId, originalIndex);
        }
      },
    }),
    [id, originalIndex, moverCard]
  );

  const [, drop] = useDrop(
    () => ({
      accept: ItemTypes.CARD,
      hover({ id: draggedId }) {
        if (draggedId !== id) {
          const { index: overIndex } = encontrarCard(id);
          moverCard(draggedId, overIndex);
        }
      },
    }),
    [encontrarCard, moverCard]
  );

  const handleInputTitulo = (event) => {
    salvarInputNomeCampo(id, event.target.value);
  };

  const handleInputObrigatorio = (event) => {
    setCheckboxObrigatorio(event.target.checked);
    salvarCheckboxObrigatorio(id, event.target.checked);
  };

  const handleDuplicar = () => {
    duplicarCard(id);
  };
  const handleExcluir = () => {
    excluirCard(id);
  };

  const opacity = isDragging ? 0 : 1;

  return (
    <div ref={(node) => drag(drop(node))} style={{ ...style, opacity }}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          style={{
            display: "flex",
            flexDirection: "row-reverse",
            marginLeft: "-15px",
            cursor:"move"
          }}
        >
          <Grid
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Grid
              style={{
                marginLeft: "10px",
              }}
            >
              <Typography
                style={{
                  fontWeight: "bolder",
                }}
              >
                Campo {ordemCampo + 1}
              </Typography>
            </Grid>
            <Grid
              style={{
                gap: "10px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                minWidth: "240px",
              }}
            >
              <Grid
                style={{
                  display: "flex",
                }}
              >
                <input
                  type="checkbox"
                  checked={checkboxObrigatorio}
                  onChange={handleInputObrigatorio}
                  id="checkboxObrigatorio"
                />
                <Typography
                  style={{
                    fontWeight: "500",
                  }}
                  htmlFor="checkboxObrigatorio"
                >
                  Obrigatório
                </Typography>
              </Grid>
              <Grid onClick={handleDuplicar}>
                <img alt="Copiar" src={Copiar} />
              </Grid>
              <Grid onClick={handleExcluir}>
                <img alt="Lixeira" src={Lixeira} />
              </Grid>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Grid
            style={{
              display: "flex",
              flexDirection: "column",
              width:"100%"
            }}
          >
            <TextField
              label="Nome do Campo"
              onKeyUp={handleInputTitulo}
              defaultValue={nomeCampo}
              placeholder="Nome do Campo"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              style={{margin: "20px 0"}}
              />            
            <Typography  variant="caption">
              Este é o nome que vai no título do campo
            </Typography>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  );
});
